<div> 
    <div >
        <div class="Tabletitle">Glacier Restore Details
        </div>
    </div>

    <div>
        <mat-form-field class="element-filter" *ngIf="docsList">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)">
        </mat-form-field>
    </div>

    <div *ngIf="noDocuments" class="docmessage card">
        <div class="card-body">
            No glacier files have been restored.
        </div>
    </div>

    <div class="container-fluid" *ngIf="!noDocuments">
        <div class="mat-elevation-z2">
        <table mat-table [dataSource]="docsList" matSort>

            <ng-container matColumnDef="srNum">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> # </th>
                <td mat-cell *matCellDef="let element;let i=index">
                    {{ (i+1) + (myPaginator.pageIndex * myPaginator.pageSize) }} </td>
            </ng-container>
            <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Title </th>
                <td mat-cell *matCellDef="let element"> {{element.title}} </td>
            </ng-container>
            <ng-container matColumnDef="requested_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Requested Date </th> 
                <td mat-cell *matCellDef="let element"> {{element.requested_date | date:'medium'}} </td> 
            </ng-container>
            <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Requested By </th>
                <td mat-cell *matCellDef="let element"> {{element.user}} </td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                <td mat-cell *matCellDef="let element"> 
                     <mat-icon class="icon" *ngIf="element.status.message.includes('Completed')" >check_circle</mat-icon>
               <mat-icon class="icon"  *ngIf="element.status.message === 'In Progress'">hourglass_full</mat-icon>  </td>
            </ng-container>
            <ng-container matColumnDef="expiration_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Expiration Date </th>
                <td mat-cell *matCellDef="let element"> {{element.expiration_date | date:'medium'}} </td>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="documentCols"></tr>
            <tr mat-row *matRowDef="let row; columns: documentCols;" class="element-row" [class.selected-row]="selectedRow === row" (click)="selectedRow = selectedRow === row ? null : row">
            </tr>
            <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr> -->

        </table>
        <mat-paginator #myPaginator [pageSizeOptions]="[5,10, 20, 50]" [pageSize]="15" showFirstLastButtons>
        </mat-paginator>
    </div>
    </div>
